module.exports = __webpack_public_path__ + "img/vincent-colyer.366deadd.png";